import { render, staticRenderFns } from "./ModalAccountChangePhone.vue?vue&type=template&id=707ac8fc&scoped=true"
import script from "./ModalAccountChangePhone.vue?vue&type=script&lang=js"
export * from "./ModalAccountChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountChangePhone.vue?vue&type=style&index=0&id=707ac8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ac8fc",
  null
  
)

export default component.exports